import { scope } from '../../hoc/withPermissions'
import { usePermission } from '../usePermission/usePermission'
import { useQuery } from '../useQuery/useQuery'

import { getGamificationDisplayConfig } from '@percent/workplace-giving/api/gamification/getGamificationDisplayConfig'

export function useGamificationEnabled() {
  const has = usePermission()
  const hasGamificationScope = has(scope('gamification'))

  const { data, isLoading } = useQuery(['getGamificationDisplayConfig'], getGamificationDisplayConfig, {
    staleTime: 1000 * 60,
    enabled: hasGamificationScope
  })

  return hasGamificationScope && !isLoading && data?.displayAchievements !== false
}
